import React from 'react';
import Icon from '../../../components/AppIcon';

const CustomerRights = () => {
  const rights = [
    {
      title: "Transparent Pricing",
      description: "You have the right to see exactly what you're paying for, with no hidden fees or surprise markups.",
      icon: "DollarSign",
      highlight: "No markups, just one 20% Service & Warranty fee"
    },
    {
      title: "Quality Guarantee",
      description: "You have the right to quality workmanship backed by our 3-year comprehensive warranty.",
      icon: "Award",
      highlight: "3-year warranty coverage"
    },
    {
      title: "Contractor Information",
      description: "You have the right to know your contractor's credentials, insurance status, and performance history.",
      icon: "UserCheck",
      highlight: "Full contractor transparency"
    },
    {
      title: "Project Timeline",
      description: "You have the right to clear project timelines and regular updates on progress.",
      icon: "Calendar",
      highlight: "Real-time project tracking"
    },
    {
      title: "Material Choice",
      description: "You have the right to choose your roofing materials from our full selection of certified brands.",
      icon: "Layers",
      highlight: "Your roof, your choice"
    },
    {
      title: "Data Privacy",
      description: "You have the right to know how your personal information is collected, used, and protected.",
      icon: "Lock",
      highlight: "Complete data transparency"
    }
  ];

  return (
    <div className="bg-white rounded-xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Heart" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="font-jakarta font-bold text-xl text-text-primary">
            Your Rights as a Customer
          </h2>
          <p className="text-text-secondary font-inter text-sm">
            We believe in empowering homeowners with clear rights and protections
          </p>
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {rights?.map((right, index) => (
          <div 
            key={index}
            className="p-4 rounded-lg border border-border hover:border-primary/30 transition-all duration-200 hover:shadow-sm"
          >
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={right?.icon} size={16} className="text-primary" />
              </div>
              
              <div className="flex-1">
                <h3 className="font-jakarta font-semibold text-text-primary mb-2">
                  {right?.title}
                </h3>
                <p className="text-sm font-inter text-text-secondary mb-3">
                  {right?.description}
                </p>
                <div className="inline-flex items-center space-x-2 bg-primary/5 px-3 py-1 rounded-full">
                  <Icon name="Star" size={12} className="text-primary" />
                  <span className="text-xs font-inter text-primary font-medium">
                    {right?.highlight}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-secondary/5 rounded-lg border border-secondary/20">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="text-secondary flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-jakarta font-semibold text-text-primary mb-1">
              Exercising Your Rights
            </h3>
            <p className="text-sm font-inter text-text-secondary">
              If you feel any of these rights have been violated, contact our customer
              advocacy team immediately at rights@openbooq.com or (937) 910-8791.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRights;